export default __webpack_public_path__ + "static/context-dont-1-dark-babec43320f53102ae53e67a2c0ebf69.png";